import { TrackDef } from '../track.js';

/**
 * SUNSPIRE DISTRICT — Neon Haven, advanced.
 * A technical night circuit through the downtown spires: a snapping esses
 * sequence, one long banked 180° sweeper, an elevated skyway with a rooftop
 * gap, and a service tunnel with a barrier squeeze on the way home.
 */
export const sunspire: TrackDef = {
  id: 'sunspire',
  name: 'Sunspire District',
  tagline: 'Downtown after dark: thread the esses, ride the skyway, survive the tunnel.',
  environment: 'neonhaven',
  difficulty: 3,
  layout: 'circuit',
  defaultLaps: 3,
  width: 24,
  unlockLevel: 6,
  points: [
    { x: 0, y: 30, z: 0, width: 26 },
    { x: 0, y: 30, z: 230, width: 26 },
    { x: -30, y: 33, z: 440, width: 22, roll: -0.2 },
    { x: 45, y: 35, z: 565, width: 20, roll: 0.22 },
    { x: -22, y: 37, z: 690, width: 20, roll: -0.22 },
    { x: 48, y: 39, z: 815, width: 20, roll: 0.2 },
    { x: 170, y: 42, z: 950, width: 22 },
    { x: 390, y: 45, z: 1010, width: 24 },
    { x: 610, y: 48, z: 970, width: 24, roll: -0.3 },
    { x: 760, y: 52, z: 820, width: 22, roll: -0.45 },
    { x: 790, y: 56, z: 620, width: 22, roll: -0.4 },
    { x: 700, y: 62, z: 440, width: 24, roll: -0.3 },
    { x: 580, y: 78, z: 230, width: 26 },
    { x: 510, y: 88, z: -30, width: 26 },
    { x: 460, y: 80, z: -280, width: 24 },
    { x: 310, y: 60, z: -450, width: 22, roll: -0.25 },
    { x: 70, y: 42, z: -520, width: 20 },
    { x: -160, y: 33, z: -430, width: 22, roll: -0.25 },
    { x: -230, y: 30, z: -190, width: 24, roll: -0.3 },
  ],
  features: [
    { kind: 'boost', s: 0.025, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.105, length: 0.11, name: 'esses' },
    { kind: 'boost', s: 0.24, length: 0.007, lane: -0.3 },
    { kind: 'zone', s: 0.56, length: 0.1, name: 'skyway' },
    { kind: 'boost', s: 0.585, length: 0.007, lane: 0.3 },
    { kind: 'jump', s: 0.625, length: 0.012 },
    { kind: 'zone', s: 0.75, length: 0.12, name: 'tunnel' },
    { kind: 'hazard', s: 0.78, length: 0.008, lane: -0.3, width: 8, type: 'barrier' },
    { kind: 'boost', s: 0.85, length: 0.007, lane: 0.2 },
  ],
  medals: { bronze: 57.6, silver: 49.6, gold: 44.3, author: 41.2 },
};
